<div class="flex items-center gap-lg pb-lg border-b border-neutral-200 mb-lg">
  <button
    type="button"
    id="profile_dropdown_back_to_main_mode_button"
    (click)="returnToMainMode()">
    <lib-chevron-down-icon
      [iconClass]="'size-6 text-neutral-900 rotate-90 rtl:rotate-270'" />
  </button>

  <p class="text-base text-neutral-800 font-medium">
    {{ selectedMenuItem()?.mainText | transloco }}
  </p>
</div>

<div class="max-h-[21.375rem] overflow-y-auto pe-lg">
  @for (subItem of subMenuItems(); track subItem.slug) {
    <lib-profile-dropdown-sub-menu-item
      [subItem]="subItem"
      (action)="selectSubMenuItem($event)" />
  }
</div>
